import { DropdownMenuGroup, DropdownMenuItem } from '@customerio/pluma-components/react';
import * as styles from './personal-settings-section.css';

export function PersonalSettingsSection() {
  return (
    <DropdownMenuGroup className={styles.settingsGroup}>
      <DropdownMenuItem href="/settings/personal">Personal settings</DropdownMenuItem>
      <DropdownMenuItem href="/settings/experimental-features">Experimental features</DropdownMenuItem>
    </DropdownMenuGroup>
  );
}
